import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { EditLandkreisDialogComponent } from './edit-dialog/edit-dialog.component';
import { Landkreis } from './landkreis';

@Component({
    selector: 'kiene-landkreise',
    templateUrl: './landkreise.component.html',
    styleUrls: ['./landkreise.component.scss'],
})
export class LandkreiseComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.headline = 'Landkreise';
        this.tableDescriptor.uniqueIdentifier = 'Landkreise';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'landkreis/';
        this.tableDescriptor.route = '/administration/landkreise/';
        this.tableDescriptor.nameOfIdField = 'landkreis_id';
        this.tableDescriptor.searchPlaceholder = 'Landkreise durchsuchen';

        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.columns.push(new TableColumn('landkreis_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('bezeichnung', 'Landkreis'));
        this.tableDescriptor.columns.push(new TableColumn('bundesland', 'Bundesland'));
        this.tableDescriptor.columns.push(new TableColumn('veterinaeramt', 'Veterinäramt'));
        this.tableDescriptor.columns.push(new TableColumn('ueberwachungsbehoerde', 'Überwachungsbehörde'));
        this.tableDescriptor.columns.push(new TableColumn('editiert', 'Editiert', 'datetime'));

        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'editieren', 'edit', 4022));

        this.tableDescriptor.initialSortColumn = 'landkreis_id';
        this.tableDescriptor.initialSortDirection = 'asc';
    }

    openEditDialog(lk: Landkreis) {
        let dialogRef = this.dialog.open(EditLandkreisDialogComponent, { width: '50%', data: { landkreis: lk } });

        dialogRef.afterClosed().subscribe(() => {
            this.tableService.reload();
        });
    }
}
